import { createContext, useEffect, useState, useContext } from 'react';
import { ErrorContext } from '../context/error-context'
import { Toast } from 'devextreme-react/toast';

export default function ToastError() {

    const [error, setError] = useContext(ErrorContext);

    const [isError, setIsError] = useState(false);

    useEffect(() => {

        if (!error || error.isSocketError)
            return;
        setIsError(!!error);
    }, [error]);

    const handleHiding = ((e) => {
        setIsError(false);
    });

    return (
        <Toast message={error}
            visible={isError}
            type="error"
            displayTime={1100}
            onHiding={handleHiding}>
        </Toast>
    );
}